import request from '@/utils/request'

/**
 * 查询平台收款母账户
 */
export function getMainAccount() {
  return request({
    url: '/api/manage/organization/account',
    method: 'get'
  })
}

/**
 * 查询平台收款账号
 */
export function getPlatformBank() {
  return request({
    url: '/api/manage/organization/account/bank',
    method: 'get'
  })
}

/**
 * 查询企业平台账号
 */
export function getPlatformAccount() {
  return request({
    url: '/api/manage/organization/account/ent',
    method: 'get'
  })
}

export default {
  getMainAccount,
  getPlatformBank,
  getPlatformAccount
}
